import { memo } from "react";
import styles from "./AppliedFilter.module.scss";
import { dateFormatter } from "../DateFormat/DateFormat";

interface AppliedFilterProps {
    filterData: any;
    onClearFilter: (updatedFilter: any) => void;
}

const AppliedFilter: React.FC<AppliedFilterProps> = ({ filterData, onClearFilter }) => {
    const clearFilter = (name: string) => {
        const updated = { ...filterData };

        switch (name) {
            case "status":
                updated.status = "";
                break;

            case "date":
                updated.fromDate = "";
                updated.toDate = "";
                break;

            default:
                updated[name] = "";
        }

        onClearFilter(updated);
    };

    const clearAllFilters = () => {
        const data = {
            status: "",
            fromDate: "",
            toDate: "",
        };
        onClearFilter(data);
    };

    const hasAnyFilter = () => {
        return (
            filterData?.status ||
            filterData?.fromDate ||
            filterData?.toDate
        );
    };

    return (
        <div className="flex flex-wrap gap-4 mb-4">
            {/* date filter */}
            {filterData?.fromDate && filterData?.toDate && (
                <div className="flex items-center gap-4 ml-4">
                    <div className={styles.filtersModeHead}>
                        <span>By Date</span>
                        <button type="button" className={`${styles.customClose}`} onClick={() => clearFilter('date')}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className={styles.filtersMode}>
                        <div className="inline-block">
                            From {dateFormatter(filterData.fromDate, 'dd MMM yyyy')}{" "}
                            To {dateFormatter(filterData.toDate, 'dd MMM yyyy')}
                        </div>
                        <button type="button" className={`${styles.customClose}`} onClick={() => clearFilter('date')}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            )}
            
            {/* status filter */}
            {filterData?.status && (
                <div className="flex items-center gap-4">
                    <div className={styles.filtersModeHead}>
                        <span>By Status</span>
                        <button type="button" className={`${styles.customClose}`} onClick={() => clearFilter('status')}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className={styles.filtersMode}>
                        <div className="inline-block">{filterData.status}</div>
                        <button type="button" className={`${styles.customClose}`} onClick={() => clearFilter('status')}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            )}

            {/* clear all filter */}
            {hasAnyFilter() && (
                <button type="button" className={`${styles.customClose} text-[#74788d]`} onClick={clearAllFilters}>
                    <span aria-hidden="true">×</span>
                    <span className="inline-block ml-2 text-[14px] font-bold">Clear Filter</span>
                </button>
            )}
        </div>
    );
};

export default memo(AppliedFilter);
